import * as React from 'react';
import type { EchoLikeStatsResponse } from '@/types/ratings';

/**
 * Context that exposes a pre-fetched echo-stats map to descendant
 * `useEchoStatsQuery` callers, so they skip their per-echo HTTP request
 * and read from the batch result instead.
 *
 * `null` (the default) means "no batch provider in the tree, fetch normally".
 */
export const BatchedEchoStatsContext = React.createContext<Map<
  string,
  EchoLikeStatsResponse
> | null>(null);
